import { Screen } from '~/screens/InternalNews/[id]/index';

export const InternalNewsDetail: React.FC = () => <Screen />;
